export default {"src":"/_next/static/media/gradient-banner.b414a816.svg","height":389,"width":1200,"blurWidth":0,"blurHeight":0};